module.exports = __webpack_public_path__ + "img/ic_myreferrals.73540048.svg";